import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input, Label } from 'reactstrap';
import { Notification } from '@shoflo/polymer/components/Notification/Notification';
import {
  StyledNotification,
  StyledControlContent,
  StyledButtonAction,
  StyledControlAction,
  StyledGroupButtonActions,
  StyledOptionAction,
  StyledSceneList,
  StyledSceneListItem,
  StyledSubTitle,
  Wrapper
} from './DeleteSource.styled';
import SourceListItem from './SceneListItem/SceneListItem';
import SourceDropDown from './SourceDropDown/SourceDropDown';

const DELETE = 'delete';
const REPLACE = 'replace';

const DeleteSource = ({
  scenes,
  sources,
  onSourceSelected,
  onCancel,
  onSubmit,
  isBackgroundSource,
  sourceType
}) => {
  const [selectedOption, setSelectedOption] = useState(DELETE);
  const [selectedSource, setSelectedSource] = useState(null);

  const disableDoneButton =
    selectedOption === '' ||
    (selectedOption === REPLACE && selectedSource === null);

  const handleOptions = value => {
    if (value === DELETE) {
      setSelectedSource(null);
    }
    setSelectedOption(value);
  };

  const handleSelectedSource = source => {
    setSelectedSource(source);
    onSourceSelected(source);
  };

  const isoverlaySource = sourceType === 'overlay';
  return (
    <Wrapper>
      <StyledSubTitle>
        {!isoverlaySource
          ? `Before you can delete this ${sourceType}, we need to determine what to do
        with the scenes that include this ${sourceType}. Please choose from one
        of the options below.`
          : `Deleting this ${sourceType} will remove it from these scenes. Are you sure you want to delete it?`}
      </StyledSubTitle>
      <StyledSceneList>
        {scenes.map(scene => (
          <StyledSceneListItem key={scene._id}>
            <SourceListItem scene={scene} />
          </StyledSceneListItem>
        ))}
      </StyledSceneList>
      {!isoverlaySource && (
        <StyledControlAction>
          <StyledOptionAction>
            <Input
              defaultChecked
              data-testid={`delete-radio-button`}
              type="radio"
              name="option"
              onClick={() => handleOptions(DELETE)}
              data-dd-action-name="Delete source from all scenes"
            />
            <Label check>Delete from all scenes</Label>
          </StyledOptionAction>
          <StyledOptionAction>
            <Input
              data-testid={`replace-radio-button`}
              type="radio"
              name="option"
              onClick={() => handleOptions(REPLACE)}
              data-dd-action-name="Replace source on all scenes"
            />
            <Label check>Replace {sourceType} on all scenes</Label>
          </StyledOptionAction>
          <SourceDropDown
            disabled={selectedOption !== REPLACE}
            defaultValue={selectedSource}
            sources={sources}
            onSourceSelected={handleSelectedSource}
            sourceType={sourceType}
          />
        </StyledControlAction>
      )}
      <StyledControlContent>
        <StyledNotification>
          {isBackgroundSource && selectedOption === DELETE && (
            <Notification
              message="Backgrounds in these scenes will become black."
              type="alert"
            />
          )}
        </StyledNotification>
        <StyledGroupButtonActions>
          <StyledButtonAction
            disabled={disableDoneButton}
            color={'primary'}
            onClick={onSubmit}
            data-testid={'delete-scene-confirm'}
            data-dd-action-name="Done selecting a source delete action"
          >
            {!isoverlaySource ? 'Done' : 'Delete'}
          </StyledButtonAction>
          <StyledButtonAction
            data-testid={'delete-scene-cancel'}
            data-dd-action-name="Cancel delete action"
            $isDefaultColor={true}
            onClick={onCancel}
          >
            Cancel
          </StyledButtonAction>
        </StyledGroupButtonActions>
      </StyledControlContent>
    </Wrapper>
  );
};

DeleteSource.defaultProps = {
  scenes: [],
  isBackgroundSource: false,
  sourceType: 'source'
};

DeleteSource.propTypes = {
  scenes: PropTypes.array.isRequired,
  isBackgroundSource: PropTypes.bool,
  sourceType: PropTypes.string,
  sources: PropTypes.array.isRequired,
  onSourceSelected: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default DeleteSource;
